import { errorMessage } from "../../lib/errors";
import { Button } from "../Button";
import { EmptyState } from "./EmptyState";

export interface QueryErrorProps {
  /** The failed query's error; ApiError messages are shown, anything else reads as a network error. */
  error?: unknown;
  onRetry?: () => void;
  size?: "default" | "compact";
  className?: string;
}

/**
 * What a page shows when its data request failed. Without it a failed query reads as an endless skeleton or as a
 * "no data" empty state, which tells the user something false. Check `isError` before `isPending` and the empty case.
 */
export function QueryError({ error, onRetry, size, className }: QueryErrorProps) {
  return (
    <div role="alert">
      <EmptyState
        title="Couldn't load this page"
        description={errorMessage(error)}
        action={
          onRetry ? (
            <Button variant="primary" onClick={() => onRetry()}>
              Try again
            </Button>
          ) : undefined
        }
        size={size}
        className={className}
      />
    </div>
  );
}
